import { memo } from 'react';
import { motion } from 'framer-motion';
import { Stack, Typography, useTheme } from '@mui/material';
import Markdown from 'react-markdown';

type AssistantMessageProps = {
    message?: { content?: string };
    isLoading?: boolean;
};

export const AssistantMessage = memo((props: AssistantMessageProps) => {
    const { message, isLoading } = props;
    const theme = useTheme();

    if (!message?.content && !isLoading) return null;

    return (
        <Stack py={2} gap={0.5}>
            {message?.content ? (
                <motion.span
                    initial={{
                        maskImage: 'linear-gradient(to right, black 0%, transparent 0%)',
                    }}
                    animate={{
                        maskImage: 'linear-gradient(to right, black 100%, transparent 0%)',
                    }}
                    transition={{
                        duration: 2,
                        ease: 'easeOut',
                    }}
                >
                    <Stack>
                        <Typography component="span">
                            <Markdown
                                components={{
                                    p: ({ children }) => (
                                        <>
                                            {children}
                                            <br />
                                        </>
                                    ),
                                    a: ({ children, href, ...props }) => (
                                        <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
                                            {children}
                                        </a>
                                    ),
                                    strong: ({ children }) => (
                                        <strong
                                            style={{
                                                fontWeight: 700,
                                                color: theme.palette.primary.main,
                                            }}
                                        >
                                            {children}
                                        </strong>
                                    ),
                                }}
                            >
                                {message.content}
                            </Markdown>
                        </Typography>
                    </Stack>
                </motion.span>
            ) : null}
        </Stack>
    );
});
